module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/06-f7f36e0f42620ccf8a9805acbe3c703b.jpg";